import { render } from "./purchaseAgreement.vue?vue&type=template&id=1c073227"
import script from "./purchaseAgreement.vue?vue&type=script&lang=js"
export * from "./purchaseAgreement.vue?vue&type=script&lang=js"

import exportComponent from "D:\\myProgram\\cloud-storage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__